"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sorted2dUpdateStrategy = void 0;
const core_1 = require("@visualization-tools/core");
const rc_js_util_1 = require("rc-js-util");
// FIXME: split this up, add tests
/**
 * @public
 * Sorts entities according to {@link IScene2d} and then batches entities to minimize draw calls. Respects
 * {@link @visualization-tools/core#ICompositeGraphicsComponent.groupUpdatesByEntity} flag.
 */
class Sorted2dUpdateStrategy {
    constructor(plot, updateGroup, scene, getUserTransform) {
        this.plot = plot;
        this.scene = scene;
        this.getUserTransform = getUserTransform;
        this.renderLists = [];
        this.isDirty = true;
        this.lastUserTransformId = -1;
        this.updateGroup = updateGroup;
        // no possibility of changing, so no need for unregistering
        core_1.OnEntityAddedToGroup.registerListener(this.plot, () => this.isDirty = true);
        core_1.OnEntityRemovedFromGroup.registerListener(this.plot, () => this.isDirty = true);
        core_1.OnEntityModified.registerListener(this.plot, () => this.isDirty = true);
        core_1.OnRendererContextLost.registerListener(this.plot.eventService, () => this.isDirty = true);
    }
    update(canvasDims, renderer) {
        const updateArg = this.updateGroup.updateArgProvider.getUpdateArg(this.plot, canvasDims);
        const currentUserTransform = this.getUserTransform(updateArg);
        if (this.lastUserTransformId !== currentUserTransform.changeId) {
            this.isDirty = true;
            this.lastUserTransformId = currentUserTransform.changeId;
            (0, core_1.resetEntityBuffers)(renderer);
            (0, core_1.resetTransformComponents)(renderer);
        }
        if (this.isDirty) {
            this.scene.update();
            this.updateRenderList(renderer, updateArg);
            this.isDirty = false;
        }
        this.drawRenderList(renderer, updateArg);
    }
    drawRenderList(renderer, updateArg) {
        const renderLists = this.renderLists;
        for (let i = 0, iEnd = renderLists.length; i < iEnd; ++i) {
            const renderList = renderLists[i];
            renderList.updateGroupHooks.onBeforeUpdate(renderer, updateArg);
            const entitiesInGroup = renderList.uniqueEntities;
            for (let j = 0, jEnd = entitiesInGroup.length; j < jEnd; ++j) {
                entitiesInGroup[j].onBeforeUpdate(updateArg);
            }
            const updateGroupings = renderList.groupings;
            for (let j = 0, jEnd = updateGroupings.length; j < jEnd; ++j) {
                const updateGrouping = updateGroupings[j];
                updateGrouping[0].drawUpdateGroup(updateGrouping[1], updateArg);
            }
            renderList.updateGroupHooks.onAfterUpdate(renderer, updateArg);
        }
    }
    updateRenderList(renderer, updateArg) {
        const categories = this.scene.getSortedCategories(this.updateGroup);
        const renderLists = this.renderLists = rc_js_util_1._Array.map(categories, category => new core_1.RenderList(category.updateHooks));
        const createEntityGrouping = Sorted2dUpdateStrategy.createEntityGrouping;
        for (let i = 0, iEnd = categories.length; i < iEnd; ++i) {
            const category = categories[i];
            const renderList = renderLists[i];
            const entitiesByComponents = this.scene.getEntitiesByComponents(category);
            for (let j = 0, jEnd = entitiesByComponents.length; j < jEnd; ++j) {
                const entitiesByComponent = entitiesByComponents[j];
                const graphicsComponent = entitiesByComponent[0];
                const entities = entitiesByComponent[1];
                renderList.addGrouping(createEntityGrouping(graphicsComponent, renderer, updateArg));
                for (let k = 0, kEnd = entities.length; k < kEnd; ++k) {
                    renderList.addEntity(entities[k]);
                }
            }
            renderList.build();
        }
    }
    static createEntityGrouping(graphicsComponent, renderer, updateArg) {
        switch (graphicsComponent.type) {
            case core_1.EGraphicsComponentType.Entity:
                {
                    const componentRenderer = renderer.componentRendererProvider.getRenderer(graphicsComponent);
                    graphicsComponent.transform.updateTransform(renderer, updateArg);
                    if (graphicsComponent.transform.transformComponent == null) {
                        return new core_1.EntityUpdateGrouping(graphicsComponent, componentRenderer);
                    }
                    else {
                        return new core_1.EntityUpdateTransformGrouping(graphicsComponent, componentRenderer, graphicsComponent.transform.transformComponent, renderer.componentRendererProvider.getRenderer(graphicsComponent.transform.transformComponent));
                    }
                }
            case core_1.EGraphicsComponentType.Composite:
                {
                    // non update by entity should have been stripped by this point
                    DEBUG_MODE && rc_js_util_1._Debug.assert(graphicsComponent.groupUpdatesByEntity, "precondition fail");
                    const graphicsComponents = [];
                    const entityRenderers = [];
                    const transformComponents = [];
                    const transformRenderers = [];
                    graphicsComponent.recurseIterate(core_1.EGraphicsComponentType.Entity, (nestedComponent) => {
                        const componentRenderer = renderer.componentRendererProvider.getRenderer(nestedComponent);
                        graphicsComponents.push(nestedComponent);
                        entityRenderers.push(componentRenderer);
                        nestedComponent.transform.updateTransform(renderer, updateArg);
                        if (nestedComponent.transform.transformComponent != null) {
                            transformComponents.push(nestedComponent.transform.transformComponent);
                            transformRenderers.push(renderer.componentRendererProvider.getRenderer(nestedComponent.transform.transformComponent));
                        }
                        else {
                            transformComponents.push(null);
                            transformRenderers.push(null);
                        }
                    });
                    return new core_1.UpdateTransformGroupingByEntity(graphicsComponents, entityRenderers, transformComponents, transformRenderers);
                }
            default:
                rc_js_util_1._Production.assertValueIsNever(graphicsComponent);
        }
    }
}
exports.Sorted2dUpdateStrategy = Sorted2dUpdateStrategy;
//# sourceMappingURL=sorted2d-update-strategy.js.map